import VoiceMessageOverview from './views/VoiceMessageOverview'

export default {
  path: '/voicemessage',
  name: 'voicemessage',
  component: VoiceMessageOverview,
  meta: {
    dark: true,
    loader: true
  }
}

